import { useFeeData } from '~/state/application/hooks'
import { useTokenPrice } from '~/hooks/useTokenPrice'
import BigNumber from 'bignumber.js'
import { formatEther, zeroAddress } from 'viem'

export const useGasFeeUSD = (gasLimit: bigint) => {
  const feeData = useFeeData()
  const gasPrice = feeData?.maxFeePerGas?.toString() || '0'
  const gasFee = formatEther(BigInt(gasPrice) * BigInt(gasLimit))

  const ETHPrice = useTokenPrice(zeroAddress)
  const gasFeeUSD = new BigNumber(ETHPrice || '0')
    .multipliedBy(gasFee)
    .toFixed(2)

  return { gasFee, gasFeeUSD }
}
